import React from "react";
import { Input } from '@material-ui/core';
import { Paper } from "@material-ui/core";
import * as S from '../formStyle';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';

function DecimalBox({
    title,
    filterName,
    handleInputChange,
    valoresRespostas,
    decimalPlaces,
    zeroValue,
    isLoading,
    ordem,
    conteudoOnChange,
    disabledList,
    componenteWidth
}) {
  const classes = S.useStyles();

  return (
    <>
        <label className={classes.label}>{title}</label>
        <Paper className={classes.medium} style={{ width: `${componenteWidth}px` }}  elevation={0}>
            <CurrencyTextField
            value={
                valoresRespostas[ordem] ?
                (valoresRespostas[ordem] !== zeroValue ? valoresRespostas[ordem] : 0)
                : 0
            }
            currencySymbol=""
            disabled={isLoading || disabledList[ordem]}
            decimalCharacter=","
            decimalPlaces={decimalPlaces}
            modifyValueOnWheel={false}
            InputProps={{
                className: classes.inputCurrency,
            }}
            digitGroupSeparator="."
            name={filterName}
            onChange={(e) => {
                handleInputChange(e, ordem, e.target.value, conteudoOnChange)
            }}
            />
        </Paper>
    </>
  );
}

export default DecimalBox;
